import { ButtonUnstyled } from 'components/Button'
import Dropdown, { DropdownProps } from './Dropdown'
import { ReactComponent as BaseEllipsisIcon } from 'icons/ellipsis-20.svg'
import React, { FC, MouseEvent } from 'react'
import styled, { css } from 'styled-components'
import { breakpoint } from 'utils'

export const DropdownButton = styled(ButtonUnstyled)`
  /* Only show on hover or in mobile */
  display: flex;
  justify-content: center;
  align-items: center;

  opacity: 0;
  color: ${({ theme }) => theme.colors.gray};
  font-size: 1.25rem;

  width: 30px;
  height: 30px;

  background-color: ${({ theme }) => theme.colors.background.light.base};
  border: 1px solid ${({ theme }) => theme.colors.border.dark.high};
  border-radius: 3px;

  box-shadow: ${({ theme }) => theme.shadows.boxShadow.subtle};

  transition: ${({ theme }) => `
    opacity ${theme.transitions.duration[0]} ${theme.transitions.timing.easeInOut},
    transform ${theme.transitions.duration[0]} ${theme.transitions.timing.easeInOut};
  `};
  transform: translate3d(0, -5px, 0);

  :focus {
    opacity: 1;
  }
  :focus-visible {
    opacity: 1;
  }
`

const DropdownButtonWrapper = styled.div`
  z-index: 1;

  position: absolute;

  top: 12px;
  right: 12px;

  ${breakpoint('xs')`
    right: 26px;
  `}

  /* Prevent the button from hiding when the dropdown is open */
  [aria-expanded='true'] ${DropdownButton} {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
`

const EllipsisIcon = styled(BaseEllipsisIcon)`
  width: 20px;
  height: 20px;
`

const handleDropdownWrapperClick = (event: MouseEvent<HTMLElement>) => {
  /* Work-around to prevent Dropdown items from triggering any parent link */
  event.stopPropagation()
}

export const cardDropdownWrapperStyle = css`
  @media (hover: none) {
    ${DropdownButton} {
      opacity: 1;
      transform: translate3d(0, 0, 0);
    }
  }

  :hover {
    ${DropdownButton} {
      opacity: 1;
      transform: translate3d(0, 0, 0);
    }
  }
`

export interface CardDropdownProps extends Partial<DropdownProps> {}

export const CardDropdown: FC<CardDropdownProps> = props => {
  const {
    children,
    placement = 'bottom',
    spacing = '10px',
    toggle = (
      <DropdownButton aria-label="Card Settings">
        <EllipsisIcon />
      </DropdownButton>
    ),
    ...rest
  }: typeof props = props

  return (
    <DropdownButtonWrapper onClick={handleDropdownWrapperClick}>
      <Dropdown
        placement={placement}
        spacing={spacing}
        toggle={toggle}
        {...rest}>
        {children}
      </Dropdown>
    </DropdownButtonWrapper>
  )
}
